import {
  Form,
  Button,
  Checkbox,
  Dropdown,
  Menu,
  message,
  Modal,
  Tabs,
  Typography,
} from "antd";
import HorizontalCard from "./HorizontalCard";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import adv from "../../assets/icons/advance.png";
import exp from "../../assets/icons/expense.png";
import report from "../../assets/icons/report.png";
import { millify } from "../../config/helper";

import BaseCurrency from "../Common/BaseCurrency";
import AddAdvance from "./../Advances/AddAdvance";
import usePayAxios from "../../config/useAxios";
import eyeOpen from "../../assets/images/eye-open.svg";
import eyeClose from "../../assets/images/eye-close.svg";
import TabPane from "antd/lib/tabs/TabPane";
// import card_activate from "../../assets/images/card_activate.png";
import { apis } from "../../config/APIs";
import { activate_card, ActivateCard } from "../../actions/cards/cards";
import clockIcon from "../../assets/icons/clock-icon.svg";
import vkycIcon from "../../assets/icons/vkyc-icon.svg";
import biometricIcon from "../../assets/icons/biometric-icon.svg";
import card_activate from "../../assets/icons/complete-kyc-icon.svg";
import { getProfile } from "../../actions/employees/employees";
import VerticalCard from "./VerticalCard";
import OTPComponent from "../Common/OTPComponent";
import { ClipLoader } from "react-spinners";
// import Base from "antd/lib/typography/Base";

const { Title } = Typography;

const TopSec = ({ card }) => {
  const history = useHistory();

  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [visibleField, setVisibleField] = useState(null);
  const [cardActivation, setCardActivation] = React.useState(false);
  const [termsModal, setTermsModal] = React.useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [showBal, setShowBal] = useState(false);
  const [isVerticalImg, setIsVerticalImg] = useState(null);
  const [ovdType, setOvdType] = useState("");
  const [ovdDetailsMap, setOvdDetailsMap] = useState({});
  const [ovdError, setOvdError] = useState("");
  const [initialOvd, setInitialOvd] = useState({
    ovdType: "",
    ovdDetails: "",
  });
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpTxnData, setOtpTxnData] = useState(null);
  console.log("OtpTxnData:", otpTxnData);
  const [otpValue, setOtpValue] = useState("");

  const { onCall: initiateKyc, loading: initiatingKyc } = usePayAxios({
    api: "/api/admin/kyc/v1/initiate",
    method: "post",
  });

  const { onCall: verifySmsOtp, loading: verifyingOtp } = usePayAxios({
    api: "/api/otps/v1/verify-sms-otp",
    method: "post",
    showSuccessMessage: false,
  });

  const { onCall: sendSmsOtp, loading: sendingOtp } = usePayAxios({
    api: "/api/otps/v1/send-sms-otp",
    method: "post",
  });

  const { onCall: submitKyc, loading: kycLoading } = usePayAxios({
    api: "/api/admin/kyc/v1",
    method: "post",
  });

  const { onCall: onCallSensitive, data: sensitiveData } = usePayAxios({
    api: "/api/cards/v1/getCardSensitiveData",
    method: "get",
    showSuccessMessage: false,
  });
  const activate_Card = useSelector((state) => state.cards.activate_card);
  const userData = useSelector(
    (state) => state.cards.profile?.data?.response?.profile,
  );

  const dashboard = useSelector(
    (state) => state.cards.reports_count?.data?.response?.dashboard || {},
  );
  const addUserAdvanceResponse = useSelector(
    (state) => state.advances.addUserAdvance || {},
  );

  useEffect(() => {
    if (userData?.ovd_type) {
      setOvdType(userData.ovd_type);

      setOvdDetailsMap({
        [userData.ovd_type]: userData.ovd_details || "",
      });

      setInitialOvd({
        ovdType: userData.ovd_type,
        ovdDetails: userData.ovd_details || "",
      });
    }
  }, [userData]);

  React.useEffect(() => {
    const { data: { status = false, message: res_message = "" } = {} } =
      addUserAdvanceResponse;
    if (status) {
      handleCancel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUserAdvanceResponse]);

  useEffect(() => {
    if (card?.id)
      onCallSensitive({
        params: {
          card_id: card?.id,
        },
      });
  }, [card?.id]);

  React.useEffect(() => {
    if (activate_Card?.data?.response?.redirectURL) {
      window.open(activate_Card?.data?.response?.redirectURL, "_blank");
      dispatch({
        type: ActivateCard.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activate_Card]);

  useEffect(() => {
    dispatch(getProfile({ user_id: sessionStorage.getItem("user_id") }));
  }, []);

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const maskCardNumber = (cardNumber) => {
    if (!cardNumber || cardNumber.length < 16) return cardNumber;
    return `XXXX XXXX XXXX ${cardNumber.slice(-4)}`;
  };
  const maskExpiryDate = (expiryDate) => (expiryDate ? "XX/XX" : "");
  const maskCVV = (cvv) => (cvv ? "XXX" : "");
  const ExpiryData = (expiryDate) =>
    expiryDate ? `${expiryDate?.slice(0, 2)}/${expiryDate?.slice(-2)}` : "";
  const formatNumber = (number) => {
    return number.replace(/(.{4})/g, "$1 ").trim();
  };

  const imageUrl = userData?.cards?.data?.imageUrl;

  useEffect(() => {
    if (!imageUrl) {
      console.log("TopSec: no imageUrl");
      return;
    }

    let isMounted = true;
    const img = new Image();

    img.onload = () => {
      if (!isMounted) return;
      const width = img.width;
      const height = img.height;
      const isVertical = height > width;
      console.log("TopSec: image dimensions:", { width, height, isVertical });
      setIsVerticalImg(isVertical);
    };

    img.onerror = (err) => {
      if (!isMounted) return;
      console.warn("TopSec: image failed to load", err);
    };
    img.src = imageUrl;

    return () => {
      isMounted = false;
    };
  }, [imageUrl]);

  const getOvdValidationRule = (ovdType) => {
    switch (ovdType) {
      case "PASSPORT":
        return {
          pattern: /^[A-Z]{1}[0-9]{7}$/,
          message:
            "Passport number must be 1 alphabet followed by 7 digits (Eg: Q2891324)",
        };

      case "VOTER_ID":
        return {
          pattern: /^[A-Z]{3}[0-9]{7}$/,
          message:
            "Voter ID must be 3 alphabets followed by 7 digits (Eg: XBG0079731)",
        };

      case "DRIVING_LICENSE":
        return {
          pattern: /^[A-Z]{2}[0-9]{2}\s[0-9]{11}$/,
          message: "Driving License format should be like TN10 12345678911",
        };

      case "NREGA_CARD_NO":
        return {
          pattern: /^[A-Z]{2}-[0-9]{2}-[0-9]{3}-[0-9]{3}-[0-9]{3}\/[0-9]{2,5}$/,
          message: "NREGA Card format should be like PB-10-011-001-001/72",
        };

      default:
        return {};
    }
  };

  const openOtpModal = async () => {
    try {
      const res = await sendSmsOtp({
        data: {
          mobileNumber: userData?.primary_phone,
          emailId: userData?.email,
          alertType: "SMS",
          actionType: "KYC_SUBMISSION",
        },
      });
      console.log("OTP sent response:", res);

      setOtpTxnData({
        txnId: res?.response?.txnId,
        otpExpiryInMinutes: res?.response?.otpExpiryInMinutes,
      });

      setOtpValue("");
      setShowOtpModal(true);
    } catch (err) {
      console.log("OTP send error:", err);
    }
  };

  const isOvdUpdated = () => {
    const currentDetails = ovdDetailsMap[ovdType] || "";

    return (
      ovdType !== initialOvd.ovdType || currentDetails !== initialOvd.ovdDetails
    );
  };

  const handleCompleteKyc = async () => {
    const currentDetails = ovdDetailsMap[ovdType] || "";

    if (!ovdType) {
      message.error(
        <span className="messageText">Please select OVD Type</span>,
      );
      return;
    }

    if (!currentDetails) {
      message.error(
        <span className="messageText">Please enter OVD Details</span>,
      );
      return;
    }

    if (ovdError) {
      message.error(
        <span className="messageText">Please fix OVD validation errors</span>,
      );
      return;
    }

    const ovdChanged = isOvdUpdated();

    const ovdTypeLabelMap = {
      PASSPORT: "Passport",
      VOTER_ID: "Voter ID",
      DRIVING_LICENSE: "DRIVING_LICENSE",
      NREGA_CARD_NO: "NREGA Card No",
    };

    if (!ovdChanged) {
      setCardActivation(false);
      setTermsModal(false);
      await openOtpModal();
      return;
    }

    const payload = {
      ovdType: ovdTypeLabelMap[ovdType] || ovdType,
      ovdDetails: currentDetails,
    };

    try {
      const response = await submitKyc({ data: payload });
      console.log("KYC submission response:", response);
      setCardActivation(false);
      await openOtpModal();
    } catch (err) {
      console.log("KYC submission error:", err);
    }
  };

  const handleVerifyOtp = async () => {
    if (!otpValue || otpValue.length !== 6) {
      message.error(
        <span className="messageText">Please enter a valid 6-digit OTP</span>,
      );
      return;
    }

    try {
      const res = await verifySmsOtp({
        data: {
          mobileNumber: userData?.primary_phone,
          emailId: userData?.email,
          otp: otpValue,
          refTxnId: otpTxnData?.txnId,
        },
      });

      if (res?.status === true && res?.response?.response === "SUCCESS") {
        try {
          const initiateRes = await initiateKyc({
            data: {
              userId: userData?.id,
            },
          });

          if (initiateRes?.status === true) {
            message.success(
              <span className="messageText">
                {initiateRes?.message || "KYC initiated successfully"}
              </span>,
            );

            setShowOtpModal(false);
            setOtpValue("");

            dispatch(getProfile({ user_id: sessionStorage.getItem("user_id") }));
          } else {
            message.error(
              <span className="messageText">
                {initiateRes?.message || "Failed to initiate KYC"}
              </span>,
            );
            setShowOtpModal(false);
            setOtpValue("");
          }
        } catch (initErr) {
          console.log("KYC initiation error:", initErr);
          setShowOtpModal(false);
          setOtpValue("");
        }
      }
    } catch (err) {
      console.log("OTP verification error:", err);
      setOtpValue("");
    }
  };

  return (
    <>
      {cardActivation && (
        <Modal
          title={<Title level={4}>Complete KYC</Title>}
          open={cardActivation}
          onCancel={() => {
            setCardActivation(false);
            setIsChecked(false);
            dispatch({
              type: ActivateCard.RESET,
            });
          }}
          footer={[]}
          className="right-alinged-modal lg"
        >
          <div className="card-activation">
            <p className="mb1 mt1 message flex-between">
              <p className="w60">
                Complete KYC
                <br />
                <span className="rbi">
                  As per RBI guidelines, you need to complete your KYC.
                </span>
              </p>
              <img src={card_activate} alt="" width={100} />
            </p>
            <div className="userContentWrapper mt1">
              <Tabs type="card" size="large" className="custom-tabs">
                <TabPane tab="Overview" key="preferences">
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}
                  >
                    {[
                      { label: "Name", value: userData?.name },
                      { label: "DOB", value: userData?.dob },
                      { label: "Gender", value: userData?.gender },
                      { label: "Occupation", value: userData?.occupation },
                      // {
                      //   label: "Source Of Income",
                      //   value: userData?.source_of_income,
                      // },
                      // {
                      //   label: "Annual Income",
                      //   value: userData?.annual_income,
                      // },
                      { label: "Nationality", value: userData?.nationality },
                      // {
                      //   label: "Customer Type",
                      //   value: userData?.customer_type,
                      // },
                      {
                        label: "Address Line 1",
                        value: userData?.address_line_1,
                      },
                      {
                        label: "Address Line 2",
                        value: userData?.address_line_2,
                      },
                      {
                        label: "Address Line 3",
                        value: userData?.address_line_3,
                      },
                      { label: "City", value: userData?.city },
                      { label: "Pincode", value: userData?.pincode },
                      { label: "State", value: userData?.state },
                      {
                        label: "Mobile Number",
                        value: userData?.primary_phone,
                      },
                      { label: "Employee ID", value: userData?.emp_id || "" },
                      { label: "Email", value: userData?.email },
                      { label: "Role", value: userData?.roles?.toString() },
                      {
                        label: "Communication Address 1",
                        value: userData?.communication_address_line_1 || "-",
                      },
                      {
                        label: "Communication Address 2",
                        value: userData?.communication_address_line_2 || "-",
                      },
                      {
                        label: "Communication Address 3",
                        value: userData?.communication_address_line_3 || "-",
                      },
                      {
                        label: "Communication City",
                        value: userData?.communication_city,
                      },
                      {
                        label: "Communication Pincode",
                        value: userData?.communication_pincode,
                      },
                      {
                        label: "Communication State",
                        value: userData?.communication_state,
                      },
                      // {
                      //   label: "Cost Center",
                      //   value: userData?.cost_center?.name,
                      // },
                      // { label: "Project", value: userData?.project?.name },
                      { label: "KYC Type", value: userData?.kyc_type || "-" },
                      {
                        label: "KYC Method",
                        value: userData?.kyc_method || "-",
                      },
                      // {
                      //   label: "Political Exposed Person",
                      //   value: userData?.political_exposed_person,
                      // },
                      // {
                      //   label: "FATCA Declaration",
                      //   value: userData?.fatca_declaration,
                      // },
                      // {
                      //   label: "PAN",
                      //   value: userData?.pan,
                      // },
                    ].map((field, index) => (
                      <div
                        key={index}
                        style={{
                          maxWidth: "14rem",
                          minWidth: "13rem",
                        }}
                      >
                        <p>
                          <b>{field.label}</b>
                        </p>
                        <p>{field.value || "-"}</p>
                      </div>
                    ))}
                    <div style={{ maxWidth: "14rem", minWidth: "13rem" }}>
                      <p>
                        <b>OVD Type</b>
                      </p>
                      <select
                        className="ant-input"
                        value={ovdType}
                        onChange={(e) => {
                          const newType = e.target.value;
                          setOvdType(newType);
                        }}
                      >
                        <option value="">Select OVD Type</option>
                        <option value="PASSPORT">Passport</option>
                        <option value="VOTER_ID">Voter ID</option>
                        <option value="DRIVING_LICENSE">Driving Licence</option>
                        <option value="NREGA_CARD_NO">NREGA Card No</option>
                      </select>
                    </div>

                    <div style={{ maxWidth: "14rem", minWidth: "13rem" }}>
                      <p>
                        <b>OVD Details</b>
                      </p>
                      <input
                        className="ant-input"
                        placeholder="Enter OVD Details"
                        value={ovdDetailsMap[ovdType] || ""}
                        onChange={(e) => {
                          const value = e.target.value.toUpperCase();

                          setOvdDetailsMap((prev) => ({
                            ...prev,
                            [ovdType]: value,
                          }));

                          const rule = getOvdValidationRule(ovdType);
                          if (rule && value && !rule.pattern.test(value)) {
                            setOvdError(rule.message);
                          } else {
                            setOvdError("");
                          }
                        }}
                      />
                      {ovdError && (
                        <p className="errorMsg" style={{ marginTop: "4px" }}>
                          {ovdError}
                        </p>
                      )}
                    </div>

                    {/* Custom Fields */}
                    {userData?.custom_fields &&
                      userData?.custom_fields.map((ele, index) => (
                        <div
                          key={`custom-${index}`}
                          style={{
                            maxWidth: "14rem",
                            minWidth: "13rem",
                          }}
                        >
                          <p>
                            <b>{ele.column_name}</b>
                          </p>
                          <p>{ele.value || "-"}</p>
                        </div>
                      ))}

                    {/* Approvers */}
                    {userData?.approvers && userData?.approvers.length > 0 && (
                      <div
                        style={{
                          maxWidth: "14rem",
                          minWidth: "13rem",
                        }}
                      >
                        <p>
                          <b>Approvers</b>
                        </p>
                        {userData?.approvers.map((ele, index) => (
                          <p
                            key={`approver-${index}`}
                          >{`${ele.name} (${ele.role})`}</p>
                        ))}
                      </div>
                    )}
                  </div>
                </TabPane>
              </Tabs>
            </div>
            {/* <ul className="mt1">
            <li>
              <p className="flex-start">
                <img src={aadhar} alt="" width={30} />
                <p>
                  <p className="title">Download Aadhar XML</p>
                  <span>
                    1. Download the Aadhar XML file from the UIDAI site.
                  </span>
                  <span>2. Login and navigate to Offline KYC</span>
                  <span>3. Set the Passcode and download</span>
                </p>
              </p>
              <p className="flex-start">
                <img src={upload_file} alt="" width={30} />
                <p>
                  <p className="title">Upload downloaded file</p>
                  <span>
                    Navigate to bank KYC page to upload the downloaded file and
                    enter details required for KYC.
                  </span>
                </p>
              </p>
              <p className="flex-start">
                <img src={kyc} alt="" width={30} />

                <p>
                  <p className="title">KYC Completed</p>
                  <span>
                    Post completion of KYC process, Your Card will be activated
                    with in 24hrs.
                  </span>
                </p>
              </p>
            </li>
          </ul> */}
          </div>
          <div className="footer-btm">
            <div className="top-filter mt1">
              <div className="flt-btns">
                <button
                  className="active primaryButton"
                  onClick={handleCompleteKyc}
                  disabled={kycLoading}
                >
                  <span>{kycLoading ? "Submitting..." : "Complete KYC"}</span>
                </button>

                <button
                  onClick={() => {
                    setCardActivation(false);
                    setIsChecked(false);
                    dispatch({
                      type: ActivateCard.RESET,
                    });
                  }}
                >
                  <span>Cancel</span>
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
      <Modal
        open={showOtpModal}
        footer={null}
        onCancel={() => {
          setShowOtpModal(false);
          setOtpValue("");
        }}
        centered
      >
        <OTPComponent
          value={otpValue}
          onChange={setOtpValue}
          loading={sendingOtp}
          source="KYC_SUBMISSION"
          label="OTP is sent on registered mobile number. Please enter OTP"
          otpData={{
            otp_token: otpTxnData?.txnId,
          }}
          resendOtp={openOtpModal}
          otpExpiryInMinutes={otpTxnData?.otpExpiryInMinutes}
        />

        <Form.Item className="loginButtonsDiv">
          <Button
            key="1"
            className="formButton mt1"
            onClick={handleVerifyOtp}
          // disabled={verifyLoading || cardTransferCreateLoading}
          >
            {verifyingOtp ? (
              <ClipLoader loading={verifyingOtp} size={15} color="white" />
            ) : (
              "Verify OTP"
            )}
          </Button>
          <Button
            key="2"
            className="cancelButton ml1 mt1"
            onClick={() => {
              setShowOtpModal(false);
              setOtpValue("");
            }}
          >
            Back
          </Button>
        </Form.Item>
      </Modal>

      <Modal
        title={<Title level={4}>Terms & Conditions</Title>}
        open={termsModal}
        onCancel={() => setTermsModal(false)}
        style={{ top: "30px" }}
      >
        <p>
          I authorize NSDL Bank and its representatives to call or SMS me with
          reference to my Prepaid Card application. This shall override registry
          on DND/ NDNC and T&C apply.
        </p>
        <p>
          I have read and understood the{" "}
          <strong
            onClick={() => {
              window.open(
                "https://ems-nsdluat.paycraftsol.in:7443/Terms%20and%20Conditions%20for%20Use%20of%20PayCraft%20Products.pdf",
                "_blank",
              );
            }}
            style={{ cursor: "pointer" }}
          >
            Terms and Conditions for Use Of PayCraft Product
          </strong>{" "}
          and agree with the same.
        </p>
        <p>
          I agree that all above information is correct and I accept all T&C
          pertaining to issuance and usage of Paycraft Prepaid Card and also
          agree to Paycraft's{" "}
          <u
            onClick={() => {
              window.open(
                "https://ems-nsdluat.paycraftsol.in:7443/Privacy%20Policy.pdf",
                "_blank",
              );
            }}
            style={{ cursor: "pointer" }}
          >
            <strong>Privacy Policy</strong>
          </u>{" "}
          .
        </p>
        <p>
          <label htmlFor="terms" style={{ color: "#262626", fontWeight: 500 }}>
            <Checkbox
              checked={isChecked}
              onChange={(e) => {
                setIsChecked(e.target.checked);
              }}
              name="terms"
            />{" "}
            I have read and agree to Terms & Conditions
          </label>
        </p>
        {/* <p className="note">
          Note:- You will be redirected to the web browser for completing the
          KYC process.
        </p> */}
        {activate_Card?.data?.message &&
          activate_Card?.data?.status === false ? (
          <p className="errorMsg">{activate_Card?.data?.message}</p>
        ) : null}
        <div className="footer-btm">
          <div className="top-filter mt1">
            <div className="flt-btns">
              <button
                className="active primaryButton"
                onClick={() => {
                  // dispatch(
                  //   activate_card({
                  //     user_id: sessionStorage.getItem("user_id"),
                  //     v1: true,
                  //   })
                  // );
                  setCardActivation(true);
                  setTermsModal(false);
                }}
                disabled={!isChecked || activate_Card?.loading}
              >
                <span>Continue</span>
              </button>
              <button
                onClick={() => {
                  setTermsModal(false);
                  setIsChecked(false);
                  dispatch({
                    type: ActivateCard.RESET,
                  });
                }}
              >
                <span>Cancel</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {card?.card_number || !userData?.id ? null : userData?.vcip_status ===
        "PENDING" ? (
        <div class="kyc-notification">
          <div class="kyc-content">
            <div class="kyc-icon flex-center">
              <img src={clockIcon} alt="Clock Icon" width={25} />
            </div>
            <div class="kyc-text">
              <h3>
                {sessionStorage.getItem("name")}, your RBI-mandated KYC is{" "}
                {userData?.vcip_status}
              </h3>
              <p>To receive your Paycraft EMS Card please complete your KYC.</p>
            </div>
          </div>
          <div class="kyc-actions">
            <button
              class="video-kyc-btn"
              onClick={() => {
                // setCardActivation(true);
                setTermsModal(true);
              }}
            >
              <img
                src={vkycIcon}
                alt="Clock Icon"
                width={18}
                className="mrHalf"
              />
              MIN KYC
            </button>
            {/* <button class="biometric-btn" disabled>
              <img
                src={biometricIcon}
                alt="Clock Icon"
                width={18}
                className="mrHalf"
              />
              Biometric
            </button> */}
          </div>
        </div>
      ) : userData?.vcip_status === "SUCCESS" ||
        userData?.vcip_status === "APPROVED" ? (
        <div className="kyc-success">
          <p>
            Thank you for completing your KYC successfully. Your card will be
            issued shortly.
          </p>
        </div>
      ) : (
        <div class="kyc-notification">
          <div class="kyc-content">
            <div class="kyc-text">
              Please click on "Video KYC" button to start the KYC process again.
            </div>
          </div>
          <div class="kyc-actions">
            <button
              class="video-kyc-btn"
              onClick={() => {
                setCardActivation(true);
              }}
            >
              <img
                src={vkycIcon}
                alt="Clock Icon"
                width={18}
                className="mrHalf"
              />
              Video KYC
            </button>
            <button class="biometric-btn" disabled>
              <img
                src={biometricIcon}
                alt="Clock Icon"
                width={18}
                className="mrHalf"
              />
              Biometric
            </button>
          </div>
        </div>
      )}
      {card && card?.id ? (
        <section className="d-flex gap1">
          <Modal
            title={
              <Title level={4}>
                New Advance &nbsp;
                <span className="text-small">Enter details and submit</span>
              </Title>
            }
            visible={isModalVisible}
            onCancel={handleCancel}
            footer={[]}
            className="right-alinged-modal"
          >
            <AddAdvance handleCancel={handleCancel} />
          </Modal>
          {isVerticalImg === false && (
            <HorizontalCard card={card} sensitiveData={sensitiveData} />
          )}
          {isVerticalImg === true && <VerticalCard card={card} />}
          <aside className="w50">
            <div className="card card-sec">
              <div className="p1" style={{ textAlign: "left" }}>
                <span className="summary-title">Pending Tasks</span>
              </div>
              <div className="tasks">
                <div className="mb1">
                  <label>Reports Pending Approval</label>
                  <span>
                    <strong>
                      <BaseCurrency />{" "}
                      {millify(dashboard?.reports_pending_approval?.amount)}
                    </strong>
                    ({dashboard?.reports_pending_approval?.count} Reports)
                  </span>
                </div>
                <div>
                  <label>Unreported Expenses</label>
                  <span>
                    <strong>
                      <BaseCurrency />{" "}
                      {millify(dashboard?.unreported_expenses?.amount)}
                    </strong>
                    ({dashboard?.unreported_expenses?.count} Expenses)
                  </span>
                </div>
                <div>
                  <label>Unsubmitted Reports</label>
                  <span>
                    <strong>
                      <BaseCurrency />{" "}
                      {millify(dashboard?.unreported_reports?.amount)}
                    </strong>
                    ({dashboard?.unreported_reports?.count} Reports)
                  </span>
                </div>
                <div>
                  <label>Unsubmitted Advances</label>
                  <span>
                    <strong>
                      <BaseCurrency />{" "}
                      {millify(dashboard?.unreported_advances?.amount)}
                    </strong>
                    ({dashboard?.unreported_advances?.count} Advances)
                  </span>
                </div>
              </div>
              <div className="d-flex quick-links">
                <div
                  className="one"
                  onClick={() => {
                    history.push("/advances/", {
                      createNew: true,
                    });
                  }}
                >
                  Create Advances
                </div>
                <div
                  className="two"
                  onClick={() => {
                    history.push("/expenses", {
                      createNew: true,
                    });
                  }}
                >
                  Create Expenses
                </div>
                <div
                  className="three"
                  onClick={() => {
                    history.push("/reports", {
                      createNew: true,
                    });
                  }}
                >
                  Create Reports
                </div>
              </div>
            </div>
          </aside>
        </section>
      ) : (
        <section className="d-flex gap1 no-card">
          <aside className="w50 card card-sec">
            <div className="flex-between p1">
              <span className="summary-title">Pending Tasks</span>
            </div>
            <div className="tasks">
              <div className="mb1">
                <label>Reports Pending Approval</label>
                <span>
                  <strong>
                    <BaseCurrency />{" "}
                    {millify(dashboard?.reports_pending_approval?.amount)}
                  </strong>
                  ({dashboard?.reports_pending_approval?.count} Reports)
                </span>
              </div>
              <div>
                <label>Unreported Expenses</label>
                <span>
                  <strong>
                    <BaseCurrency />{" "}
                    {millify(dashboard?.unreported_expenses?.amount)}
                  </strong>
                  ({dashboard?.unreported_expenses?.count} Expenses)
                </span>
              </div>
              <div>
                <label>Unsubmitted Reports</label>
                <span>
                  <strong>
                    <BaseCurrency />{" "}
                    {millify(dashboard?.unreported_reports?.amount)}
                  </strong>
                  ({dashboard?.unreported_reports?.count} Reports)
                </span>
              </div>
              <div>
                <label>Unsubmitted Advances</label>
                <span>
                  <strong>
                    <BaseCurrency />{" "}
                    {millify(dashboard?.unreported_advances?.amount)}
                  </strong>
                  ({dashboard?.unreported_advances?.count} Advances)
                </span>
              </div>
            </div>
          </aside>
          <aside className="w50">
            <div className="card card-sec">
              <div className="p1">
                <span className="summary-title">Quick Links</span>
              </div>
              <div className="d-flex quick-links">
                <div
                  className="one"
                  onClick={() => {
                    history.push("/advances/", {
                      createNew: true,
                    });
                  }}
                >
                  <span className="flex-center">
                    <img src={adv} alt="" width={18} />
                  </span>
                  Create Advances
                </div>
                <div
                  className="two"
                  onClick={() => {
                    history.push("/expenses", {
                      createNew: true,
                    });
                  }}
                >
                  <span className="flex-center">
                    <img src={exp} alt="" width={18} />
                  </span>
                  Create Expenses
                </div>
                <div
                  className="three"
                  onClick={() => {
                    history.push("/reports", {
                      createNew: true,
                    });
                  }}
                >
                  <span className="flex-center">
                    <img src={report} alt="" width={18} />
                  </span>
                  Create Reports
                </div>
              </div>
            </div>
          </aside>
        </section>
      )}
    </>
  );
};

export default TopSec;

const EyeComponent = ({ image }) => {
  return (
    <div style={{ display: "contents" }}>
      <img src={image} alt="eye image" />
    </div>
  );
};
